import type { ReactNode } from 'react';
import { useAuthData } from '~/hooks/auth/use-auth-data';
import { NoPaymentModal } from './NoPaymentModal';
import { shouldShowPaymentModal } from './payment-required';

export function PaymentRequiredWrapper({ children }: { children: ReactNode }) {
  const { orgMetadata, isSuperAdmin } = useAuthData();

  // Use client-side check to determine if payment modal should be shown
  const showPaymentModal = shouldShowPaymentModal({ orgMetadata, isSuperAdmin });

  return (
    <>
      {!!showPaymentModal && <NoPaymentModal />}
      {children}
    </>
  );
}
